import declare from "dojo/_base/declare";
import Controller from "csi/action/Controller";
import session from "csi/session";
import { setLocationHash } from "csi/utility/routerUtility";

const _StartApprovalWorkflowMixin = declare(null, {
	/**
	 * Navigate to new revision
	 */
	postProcessSuccess() {
		const	master = Controller.prototype.getParent.call(this);
		const revisionUrl = master.Revisions.last();
		const params = {};
		params[session.LOCATION_URL] = revisionUrl;
		params[session.LOCATION_TAB] = "ApprovalWorkflow";
		setLocationHash(session.getLocation(null, params));
	},
});
export = _StartApprovalWorkflowMixin;